import { provideGalaxyDateAdapter } from '@vendasta/galaxy/datepicker';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { FilterFieldComponent } from '../filter-field.component';
import { DatePickerFilterField } from './filter-field-date-picker';

@Component({
  selector: 'va-filter-date-picker',
  template: `
    <glxy-form-field size="small">
      <input
        matInput
        [matDatepicker]="picker"
        (click)="picker.open()"
        [value]="filterField.value"
        (dateChange)="dateChange($event)"
      />
      <glxy-label>{{ '' + filterField.name | translate }}</glxy-label>
      <mat-datepicker-toggle matSuffix [for]="picker" />
      <mat-datepicker #picker />
    </glxy-form-field>
  `,
  styles: [
    `
      :host {
        display: block;
        margin-bottom: -24px;
      }
    `,
  ],
  providers: [
    ...provideGalaxyDateAdapter(),
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DatePickerFilterFieldComponent extends FilterFieldComponent<DatePickerFilterField> {
  dateChange(event: MatDatepickerInputEvent<Date>): void {
    this.applyFilter(event.value);
  }
}
